module.exports = __webpack_public_path__ + "2a138e4f1c7c70d52f86d5a5081da957.jpg";